import { SolvReduxState } from '../reducers';
import { EN, ES, SupportedLocale } from '../core/util/localizedStr';
import { NewBookingState } from '../reducers/newBooking';

export const getNewBooking = (state: SolvReduxState): NewBookingState => state?.newBooking ?? null;

export const getPrimaryPatientFullName = (state: SolvReduxState): string => {
  const { firstName = '', lastName = '' } = getNewBooking(state)?.profile;
  return `${firstName} ${lastName}`.trim();
};

export const getPrimaryPatientFirstName = (state: SolvReduxState): string => {
  const { firstName = '' } = getNewBooking(state)?.profile;
  return firstName;
};

export const getNewBookingLocale = (state: SolvReduxState): SupportedLocale => {
  const newBooking = getNewBooking(state);

  const locale = newBooking?.locale;

  if ((locale as any) === 'en-us') {
    return EN;
  }

  if ((locale as any) === 'es-us') {
    return ES;
  }

  if (locale) {
    return locale;
  }

  return EN;
};
